import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/exchange-rate", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/exchange-rate/csv", params);
};

const upsert = data => {
  return restApi.post("/api/exchange-rate/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/exchange-rate/${ids}`);
};

const exchangeRateService = {
  getAll,
  getAllForCSV,
  upsert,
  remove
};

export default exchangeRateService;